/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday April 1st 2024
 * Author: KasunKarunasekara
 * -----
 * Last Modified: Monday April 1st 2024 12:52:44 pm
 * Modified By: KasunKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2024 Mitra Sparks
 * -----
 * HISTORY:
 */

import { createSlice } from '@reduxjs/toolkit';
import { checkUndefinedOrNull } from 'src/utils/functions';
import axios from '../../utils/axios';

const initialState = {
  isInitiativesLoading: false,
  greenInitiatives: []
};

const slice = createSlice({
  name: 'esgMarketplace',
  initialState,
  reducers: {
    //START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    //START INITIATIVES LOADING
    startInitiativesLoading(state) {
      state.isInitiativesLoading = true;
    },
    //HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.isInitiativesLoading = false;
    },
    //GET INITIATIVES SUCCESS
    getInitiativesSuccess(state, action) {
      state.isInitiativesLoading = false;
      state.greenInitiatives = action.payload;
    }
  }
});

export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------

export function getInitiatives(filterQuery) {
  console.log('FILTER CRITERIA', filterQuery);
  return async (dispatch) => {
    dispatch(slice.actions.startInitiativesLoading());
    try {
      const response = await axios.get('/esg-marketplace/green-initiatives', {
        params: {
          filterQuery
        }
      });
      dispatch(slice.actions.getInitiativesSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export async function postEnrollToInitiative(initiative) {
  let payload = { ...initiative };
  try {
    const response = await axios.post(
      `/esg-marketplace/green-initiatives/enroll`,
      {
        ...payload
      }
    );
    return response;
  } catch (error) {
    return error;
  }
}
